/* eslint-disable jsx-a11y/anchor-has-content */
import style from './ScrollDownArrow.module.scss';

export const ScrollDownArrow = ({ linkToId }: { linkToId: string }) => (
  <div className={style.container}>
    <a className={style.arrow} href={`#${linkToId}`} />
  </div>
);
